import { useAppSelector } from "integrations/redux/hooks"
import { LayerPluginSpec } from "plugins/plugin-registry"
import { createGenericSidePanelStateSelector } from "../selectors"
import { Layer, MessageFns } from "@nova/protobuf"
import { RootState } from "integrations/redux"

export function getGenericUseSidePanelEntities(spec: LayerPluginSpec) {
    return () =>
        useAppSelector(
            createGenericSidePanelStateSelector(
                spec.protobufMessage.create,
                spec.selectSingleEntity,
                spec.selectAllEntities
            )
        )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getUseSidePanelEntities<T extends Layer = any>({
    protobufMessage,
    selectSingleEntity,
    selectAllEntities,
}: {
    protobufMessage: MessageFns<T>
    selectSingleEntity: (id: string) => (s: RootState) => T
    selectAllEntities: (s: RootState) => T[]
}) {
    return () =>
        useAppSelector(
            createGenericSidePanelStateSelector(
                protobufMessage.create,
                selectSingleEntity,
                selectAllEntities
            )
        )
}
